import React from 'react'
import { StyledSecondForm } from './styled'
import { API } from 'javascripts/api'
import { FormProvider, useForm } from 'react-hook-form'
import { FormType, OnChangeStep } from '../types'
import { WorkPreference, WorkPreferenceFormFormGroupEnum } from 'javascripts/api/generated'
import { useConfirmationBeforeUnload } from '../hooks/useConfirmationBeforeUnload'
import { WorkPreferenceFormNames } from '../../constants'
import { useAtom } from 'jotai'
import { stateAtom } from 'spa/member/atoms/WorkPreference/stateAtom'

type Props = {
  formType: FormType
  onChangeStep: OnChangeStep
}

export const SecondForm: React.FC<Props> = (props: Props) => {
  const [_state, setState] = useAtom(stateAtom)

  const { ...method } = useForm({
    defaultValues: async () => {
      const response = await API.getWorkPreference()
      const json: WorkPreference = response.data
      const desiredMonthlySalary = json?.desired_monthly_salary || 600000

      return {
        desired_monthly_salary: desiredMonthlySalary,
        _desired_hourly_salary: Math.ceil(desiredMonthlySalary / 160).toLocaleString(),
        additional_conditions: json?.additional_conditions,
        full_time_job_introduction: json?.full_time_job_introduction?.toString(),
        temp_job_introduction: json?.temp_job_introduction?.toString(),
        pre_communication_notes: json?.pre_communication_notes,
      }
    },
  })

  useConfirmationBeforeUnload(props.formType, method.formState.isDirty)

  const onSubmit = async (data) => {
    setState(prev => ({...prev, sending: true }))

    const {
      _desired_hourly_salary,
      ...sendData
    } = data

    const formattedData = {
      ...sendData,
      temp_job_introduction: sendData.temp_job_introduction === "true",
      full_time_job_introduction: sendData.full_time_job_introduction === "true",
      desired_monthly_salary: Number(sendData.desired_monthly_salary),
      form_group: WorkPreferenceFormFormGroupEnum.JobOfferPreference,
    }

    try {
      await API.updateWorkPreference(formattedData)
    } catch (error) {
      window.alert('エラーが発生しました。')
      return
    } finally {
      setState(prev => ({...prev, sending: false }))
    }

    // defaultValuesを再設定して、isDirtyの値をリセットする
    method.reset(data)

    props.onChangeStep('next')
  }

  return (
    <FormProvider {...method}>
      <form id={WorkPreferenceFormNames.DesiredProject} onSubmit={method.handleSubmit(onSubmit)} noValidate>
        <StyledSecondForm formType={props.formType} />
      </form>
    </FormProvider>
  )
}

